import appService from 'services/common';

const getStaticPageManageApi = () => {
  return appService.get('/static-pages-manage');
};

export { getStaticPageManageApi };
